import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_OnSpotlightMode = new ThunderDispatcher('__onSpotlightMode');
//# sourceMappingURL=dispatcher.js.map